import { render } from "./SpendPlanManagement.vue?vue&type=template&id=48957384"
import script from "./SpendPlanManagement.vue?vue&type=script&lang=js"
export * from "./SpendPlanManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__